<!-- 创建时间2023/06/19 10:37:04 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：相关方设置 : 选人、选讲师、自己输入+搜索-->
<template>
  <div>
    <yxt-autocomplete
      v-if="type === 0"
      class="width-percent-100-i"
      v-model="_value"
      :disabled="disabled"
      :maxlength="36"
      :hide-loading="false"
      :debounce="800"
      :fetch-suggestions="search"
      :placeholder="$t('pc_kng_custom_lbl_please_fill_in'/** 请填写 */)"
      @select="select"
    >
      <template slot-scope="scope">
        <yxtbiz-user-name :name="scope.item.value" />
      </template>
    </yxt-autocomplete>
    <yxt-select
      v-else
      class="width-percent-100-i"
      v-model="multiValue"
      multiple
      :placeholder="$t('pc_select_placeholder'/** 请选择 */)"
      icon-name="more"
      hidden-option
      collapse-tags
      value-key="id"
      prop-label="name"
      size="small"
      :disabled="disabled"
      @click.native="open"
      @remove-tag="remove"
    >
      <template slot="tag" slot-scope="{ data }">
        <span>{{ data.currentLabel }}</span>
      </template>
    </yxt-select>

    <!-- 
    讲师：Courselecturer_extent
    辅讲：CourseAssistantlecturer_extent
    贡献者：CourseOwner_extent 
    -->
    <yxt-drawer :visible.sync="visible" size="960px">
      <yxtbiz-teacher-selector
        v-if="type === 2"
        v-model="user"
        :functionCode="functionCode"
        :dataPermissionCode="dataPermissionCode"
      />
      <yxtbiz-range-selector
        v-else
        v-model="user"
        :multiple="false"
        :tabs="[{type:'persons', isShowDeptment: true}]"
        :functionCode="functionCode"
        dataPermissionCode="CourseOwner_extent"
      />
      <div slot="footer">
        <yxt-button plain @click="cancel">{{ $t('pc_biz_comment_cancel'/** 取消 */) }}</yxt-button>
        <yxt-button type="primary" @click="confirm">{{ $t('pc_biz_common_btn_sure'/** 确定 */) }}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
import { postAssociate } from 'yxt-biz-pc/packages/kng-operator/service';
export default {
  name: 'form-related',
  inject: ['getFunctionCode', 'getAttrConfigs'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    id: { // 人id或者不限
      type: String,
      default: ''
    },
    name: {// 人 name
      type: String,
      default: ''
    },
    isCustom: {
      type: Boolean,
      default: false
    },
    attrId: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchList: [],
      visible: false,
      user: {}
    };
  },
  computed: {
    attrConfigs() {
      return this.getAttrConfigs();
    },
    type() {
      // 0不限，1组织架构内，2企业讲师debugger
      if (!this.attrId) return 1;
      return (this.attrConfigs.find(item => item.id === this.attrId) || {}).selectRange || 0;
    },
    functionCode() {
      return this.getFunctionCode();
    },
    _value: {
      get() {
        if (this.isCustom) {
          return this.id;
        }
        return this.name;
      },
      set(val) {
        if (this.isCustom) {
          this.$emit('update:id', val);
        }
        this.$emit('update:name', val);
      }
    },
    multiValue: {
      get() {
        return this.id ? [{ id: this.id, name: this.name }] : [];
      },
      set() {}
    }
  },
  methods: {
    // 作者搜索
    async search(val, cb) {
      if (val) {
        this.authorLists = [];
        const res = await postAssociate({ fullname: val });
        if (res.length) {
          this.searchList = res.map(item => {
            return { id: item.id, value: item.fullname };
          });
        }
      }
      this.$nextTick(() => cb(this.searchList));
    },
    select(val) {
      this.$emit('update:name', val.value);
    },
    open() {
      if (this.disabled) return;
      this.user = this.id ? { id: this.id, fullname: this.name } : {};
      this.visible = true;
    },
    cancel() {
      this.visible = false;
    },
    confirm() {
      if (!this.user) this.user = {};
      this.$emit('update:id', this.user.id);
      this.$emit('update:name', this.user.fullname);
      this.visible = false;
    },
    remove() {
      this.$emit('update:id', '');
      this.$emit('update:name', '');
    }
  }
};
</script>